import React from 'react';
import { Link } from 'react-router-dom';
import AssistantEntityCards from './AssistantEntityCards';
import { normalizeEntities, splitAssistantText } from '../../utils/assistantEntities';
import { visibleActions } from '../../utils/assistantFlow';

const AssistantReply = ({ text, entities, actions, href, hrefLabel }) => {
  const { heading, body } = splitAssistantText(text);
  const cards = normalizeEntities(entities);
  const links = visibleActions(actions);

  return (
    <div>
      {heading ? <p className="text-sm font-semibold tracking-tight text-slate-900">{heading}</p> : null}
      {body ? (
        <p className={`whitespace-pre-wrap text-sm leading-relaxed ${heading ? 'mt-1 text-slate-600' : 'text-slate-800'}`}>
          {body}
        </p>
      ) : null}
      {href ? (
        <Link to={href} className="btn btn-outline btn-sm mt-3">
          {hrefLabel}
        </Link>
      ) : null}
      <AssistantEntityCards entities={cards} />
      {links.length > 0 ? (
        <div className="mt-3 flex flex-wrap gap-2">
          {links.map((action) => (
            <Link key={action.path} to={action.path} className="btn btn-outline btn-sm">
              {action.label}
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default AssistantReply;
